import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment.prod';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabase } from '@angular/fire/database';
import { UsersFormComponent } from './admin/users-form/users-form.component';
import { AdminUsersComponent } from './admin/admin-users/admin-users.component';
import { UserService } from './services/user.service';
import { PrivateSectorComponent } from './admin/private-sector/private-sector.component';
import { PrivateSectorScContentComponent } from './admin/private-sector/private-sector-sc-content/private-sector-sc-content.component';
import { PrivateSectorEditComponent } from './admin/private-sector/private-sector-edit/private-sector-edit.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    PrivacyComponent,
    ContactComponent,
    AboutComponent,
    LoginComponent,
    AdminComponent,
    UsersFormComponent,
    AdminUsersComponent,
    PrivateSectorComponent,
    PrivateSectorScContentComponent,
    PrivateSectorEditComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    ReactiveFormsModule
  ],
  providers: [
    AuthService,
    AuthGuardService,
    UserService,
    AngularFireDatabase
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
